import type { AuditEventType } from './api/auditApi';

export interface AuditEventsQuery {
  search: string;
  eventType: AuditEventType | 'all';
  days: number;
  page: number;
}

export const auditKeys = {
  events: (query: AuditEventsQuery) =>
    ['audit', 'events', query.search, query.eventType, query.days, query.page] as const,
  /** Prefix of events(...) for every query — invalidates the whole list at once. */
  eventsPrefix: () => ['audit', 'events'] as const,
  summary: () => ['audit', 'summary'] as const,
  session: (sessionId: string) => ['audit', 'session', sessionId] as const,
};
